/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".puntos[_ngcontent-%COMP%]{width:20px;height:20px;display:flex;justify-content:center;align-items:center;margin-right:2px}"];
export { styles as styles };
